module.exports = __webpack_public_path__ + "static/nav-grid.b83c7a16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav-grid.jpg
// module id = 540
// module chunks = 168707334958949